import { render, staticRenderFns } from "./checkPaper.vue?vue&type=template&id=127db747&scoped=true&"
import script from "./checkPaper.vue?vue&type=script&lang=js&"
export * from "./checkPaper.vue?vue&type=script&lang=js&"
import style0 from "./checkPaper.vue?vue&type=style&index=0&id=127db747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127db747",
  null
  
)

export default component.exports